import * as Sentry from '@sentry/react'
import { isOnlineByHostname } from '@/store/tools'

export default Sentry

// Sentry.init({
//   // dsn: "http://3d090995c21cac2050c09a46f2d1f7f7@114.116.229.98:9000/2",
//   dsn: 'https://3d090995c21cac2050c09a46f2d1f7f7@sentry.zhongheschool.com/2',
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       // tracePropagationTargets: ["localhost", /zhumavip.com/,/zhongheschool.com/],
//     }),
//     new Sentry.Replay()
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of the transactions
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0 //
// })
// < script
// src = "http://114.116.229.98:9000/js-sdk-loader/3d090995c21cac2050c09a46f2d1f7f7.min.js"
// crossOrigin = "anonymous" > < /script>
Sentry.init({
  environment: isOnlineByHostname() ? 'production' : 'test',
  // dsn: "http://950da0639cb36ca04e3391d4db45b8d3@114.116.229.98:9000/5",
  dsn: 'https://3d090995c21cac2050c09a46f2d1f7f7@sentry.zhongheschool.com/2',
  integrations: [
    new Sentry.BrowserTracing({
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', /zhumavip.com/, /zhongheschool.com/]
    }),
    new Sentry.Replay()
  ],
  ignoreErrors:['defaultPlaybackRate','defaults','googletag','chrome-extension','shortcut','sentry','sdk','Loading CSS chunk','bot','aborted','play','Helpful','XMLHttpRequestProgressEvent','ProgressEvent','Request','title','request','non-array'],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you'rexs not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

// 每次接口请求的数据 入参和出参
// 用户数据
